
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/8-off-the-beaten-track-places-to-visit-in-iceland",
      function () {
        return require("private-next-pages/blog/8-off-the-beaten-track-places-to-visit-in-iceland.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/8-off-the-beaten-track-places-to-visit-in-iceland"])
      });
    }
  